import React, { Component } from 'react'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { connect } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/src/jquery';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'font-awesome/css/font-awesome.min.css';
//import "react-table-6/react-table.css";
import './style/admin.css';
import './style/auth.css';
import './style/book.css';
import './style/general.css';
import './style/main-landing.css';
import './style/ridley-style.css';
import './style/style.css';
//import MainPage from 'pages/MainPage';
import { BookPage } from 'pages/BookPage';
import { AdminPage } from 'pages/AdminPage';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { history } from './redux/_helpers';
import { alertActions, userActions, coachActions } from './redux/_actions';
import LanguageSelector from 'components/LanguageSelector';

class App extends Component {
    state = {};
    constructor(props) {
        super(props);

        history.listen((location, action) => {
                // clear alert on location change
                this.props.clearAlerts();
        });
    }
	
    componentDidMount() {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                let userId = user.uid;
                this.props.checkLogin(userId);
            }
        });
    }

    render() {
        return (
            <div>
                <Router history={history}>
                    <Switch>
                        <Route exact path="/" component={BookPage} />
                        <Route exact path="/book/:storeId" component={BookPage} />
                        <Route exact path="/retry/:deliveryId" component={BookPage} />
                        {/* <Route exact path="/book" component={BookPage} /> */}
                        <Route exact path="/admin" component={AdminPage} />
                        <Redirect from="*" to="/" />
                    </Switch>
                </Router>
                <LanguageSelector />
            </div>
		);
	}
}

function mapState(state) {
    const { alert } = state;
    const { loggingIn, user } = state.authentication;
    return { alert, loggingIn, user };
}

const actionCreators = {
    clearAlerts: alertActions.clear,
    checkLogin: userActions.checkLogin,
    checkMembership: coachActions.checkMembership,
};

const connectedApp = connect(mapState, actionCreators)(App);
export { connectedApp as App };
